import { ChangeEventHandler, FC, Fragment, useState } from "react";
import { Dialog, DialogPanel } from "@headlessui/react";
import { t } from "i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBowlFood } from "@fortawesome/pro-regular-svg-icons";

import { ButtonSecondary } from "../atoms/ButtonSecondary";
import { TabsUser } from "./TabsUser";
import { Meal } from "@/app/nutrition/meal.enum";
import { NutritionSearchValues } from "@/app/nutrition/search.schema";
import { SearchDishes } from "./SearchDishes";
import { SearchSuplementation } from "./SearchSuplementation";

export type NutritionSideBarProps = {
  visible?: boolean;
  currentPage: number;
  dishes: Array<any>;
  isLoading: boolean;
  lastPage: number;
  onChange: ChangeEventHandler<HTMLInputElement>;
  onPageChange: (page: number) => void;
  onSetDish: (meal: Meal, dish: any) => void;
  onSetSuplementation: (suplementation: any, meal: Meal) => void;
  perPage: number;
  setFieldValue: (field: string, value: any) => void;
  suplementations: Array<any>;
  total: number;
  values: NutritionSearchValues;
  multiple?: boolean;

  tabsFood: { id: number; name: string }[];
  selectTabFood: number;
  handleTabChangeFood: (tabId: any) => void;
  onSuggestNewDish: () => void;
};

export const NutritionSideBar: FC<NutritionSideBarProps> = ({
  visible,
  onPageChange,
  currentPage,
  lastPage,
  perPage,
  total,
  onChange,
  values,
  isLoading,
  onSetDish,
  onSetSuplementation,
  suplementations,
  dishes,
  setFieldValue,
  tabsFood,
  selectTabFood,
  handleTabChangeFood,
  onSuggestNewDish: onSuggestNewDish,
}) => {
  const [active, setActive] = useState(false);

  const handleHoverStart = () => {
    setActive(true);
  };

  const handleHoverEnd = () => {
    setActive(false);
  };

  return (
    <div className="overflow-visible relative w-full border-l border-gray-200 h-full">
      <aside
        className={`bg-white border-grey-700 ${active ? "shadow-md" : ""} w-full absolute flex-col`}
        onMouseEnter={handleHoverStart}
        style={{ height: "100%", zIndex: 2 }}
      >
        <nav className="flex flex-1 flex-col">
          <div
            className="flex flex-col h-full my-auto fixed text-center p-2 items-center justify-center"
            style={{ width: "9%" }}
          >
            <div className="w-full rounded-lg mb-32 p-4 border-2 border-dashed border-gray-300 text-center">
              <FontAwesomeIcon
                icon={faBowlFood}
                className="mx-auto h-24 w-12 text-gray-400"
              />
              <span className="mt-2 block text-sm font-semibold text-gray-900">
                {t("user.views.add_food")}
              </span>
            </div>
          </div>
          <div
            className={`${active ? "" : "hidden"} fixed top-0 right-0 bottom-0 z-10 bg-white w-[35vw] shadow-xl flex flex-col h-screen pb-2`}
            onMouseLeave={(event) => setActive(false)}
          >
            <div className="flex flex-col flex-0 col-span-full p-4 pb-0">
              <TabsUser
                tabs={tabsFood}
                selectedTab={selectTabFood}
                handleTabChange={handleTabChangeFood}
                button={
                  <ButtonSecondary
                    size="large"
                    text={t("user.views.request_meal")}
                    onClick={onSuggestNewDish}
                  />
                }
              />
            </div>
            <div className="flex flex-col flex-1">
              {selectTabFood === 1 ? (
                <SearchDishes
                  currentPage={currentPage}
                  dishes={dishes}
                  lastPage={lastPage}
                  onChange={onChange}
                  onPageChange={onPageChange}
                  onSetDish={onSetDish}
                  perPage={perPage}
                  setFieldValue={setFieldValue}
                  total={total}
                  values={values}
                  isLoading={isLoading}
                />
              ) : (
                <SearchSuplementation
                  onChange={onChange}
                  data={suplementations}
                  search={values.suplementation}
                  onSetSuplementation={onSetSuplementation}
                />
              )}
            </div>
          </div>
        </nav>
      </aside>
    </div>
  );
};

type Option = {
  id: number | string;
  name: string;
};

type OptionsFood = {
  id: number | string;
  products: string[];
};

type DialogInformationProps = {
  onClose: () => void;
  dialogVisible: boolean;
  optionsSelect: Option[];
  selectOptions: Option;
  setSelectOptions: (option: Option) => void;
  onBreakFast: () => void;
  onMediaMana: () => void;
  onLunch: () => void;
  onSnack: () => void;
  onDinner: () => void;
  onPoscena: () => void;
  options: { id: string | number; name: string }[];
  tabsFood: { id: number; name: string }[];
  selectTabFood: number;
  handleTabChangeFood: (tabId: any) => void;
  optionsFood: OptionsFood[];
  handleOpenModalSuggestNewPlate: () => void;
};
